import { SAlert, SBack } from "shj-components";
import { Button, Tabs } from "antd";

import styles from '../../index.module.less'
import GlobalRuleForm from "./GlobalRuleForm";
import CompetitionRuleTable from "./CompetitionRuleTable";
import GeneralRuleTable from "./GeneralRuleTable";
import { AddOrEditModal } from "@/pages/baseProduct/productMonitor/components/tabs/GlobalRuleForm/addOrEditModal.tsx";
import { useSetState } from "ahooks";
import { InfoCircleFilled } from "@ant-design/icons";

const RuleConfiguration = () => {
  const [state, setState] = useSetState({
    open: false,
    reload: false,
    activeKey: 'global'
  })

  const items = [
    { key: 'global', label: '全局规则', children: <GlobalRuleForm reload={state.reload}/> },
    { key: '2', label: '竞争定价预警规则', children: <CompetitionRuleTable/> },
    { key: '3', label: '通项标配预警规则', children: <GeneralRuleTable/> },
  ]

  return <div className={styles.ruleConfigPage}>
    <SBack level={2} title="规则配置" >
      <SAlert type="info" icon={<InfoCircleFilled style={{fontSize: 16}} />}>配置修改后，将于次日生效</SAlert>
      <div className={styles.tabWrap}>
        <Tabs items={items} activeKey={state.activeKey}
              onChange={key => setState({activeKey: key})}
              tabBarExtraContent={state.activeKey === 'global' ? <Button type={'primary'} onClick={() => setState({open: true})}>编辑</Button> : null}/>
      </div>
    </SBack>
    {state.open && <AddOrEditModal
      open={state.open}
      onClose={() => setState({ open: false })}
      onReload={() => setState({ reload: !state.reload })}
    />}
  </div>
}

export default RuleConfiguration